"use client";

import Link from "next/link";
import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { Badge } from "@mui/material";
import { uid } from "@/utils/fncts";
import { useTranslation } from "react-i18next";
import { BiCartAdd } from "react-icons/bi";
import { MdOutlineReportProblem } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { IoIosInformationCircleOutline, IoMdLogIn } from "react-icons/io";
import { useSession } from "next-auth/react";
import { UserSession } from "@/utils/types";
import { GoHome } from "react-icons/go";
import { FiShoppingBag } from "react-icons/fi";
import { FaRegHeart } from "react-icons/fa";
import { FaQ } from "react-icons/fa6";
import { IoCarSportOutline, IoInformationSharp, IoSearch } from "react-icons/io5";
import { getSocket } from "@/utils/sharedUtils";
const BottomNavBar = ({
  initialNavItems,
}: {
  initialNavItems: {
    path: string;
    icon: JSX.Element | string;
    label: string;
  }[];
}) => {
  const [navItems, setNavItems] = useState(
    initialNavItems as {
      path: string;
      icon: JSX.Element | string;
      label: string;
    }[]
  );
  const pathname = usePathname();
  const session = useSession().data as UserSession;
  const [notif, setNotif] = useState<string[]>([]);
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";
 const socket = getSocket();;
  if (socket) {
    socket.emit("join_room", { roomId: "admin", id: "bottomnavbar" });
  }
  useEffect(() => {
    if (socket) {
      socket.on("receive_msg", (data) => {
        notif.push(data.new);
        setNotif(notif);
      });
    }
  }, []);

  
    useEffect(() => {
      if (!session) {
        setNavItems([
          { path: "/", icon: <GoHome />, label: "/" },
          { path: "/shop", icon: <FiShoppingBag />, label: "shop" },
         
          { path: "/about", icon: <IoInformationSharp />, label: "about" },
          { path: "/faq", icon: <FaQ />, label: "about" },
        ]);

        return;
      }
      if (session && session?.role != "admin" && session?.role != "super-admin") {
        setNavItems([
          { path: "/", icon: <GoHome />, label: "/" },
          { path: "/shop", icon: <FiShoppingBag />, label: "shop" },
          { path: "/my_space?tab=orders", icon: <BiCartAdd />, label: "orders" },
          {
            path: "/my_space?tab=conflicts",
            icon: <MdOutlineReportProblem />,
            label: "conflicts",
          },
          {
            path: "/sourcing",
            icon: <IoSearch />,
            label: "sourcing",
          },
          {
            path: "/cars",
            icon: <IoCarSportOutline />,
            label: "cars",
          },
          { path: "/my_space?tab=favorites", icon: <FaRegHeart />, label: "profile" },
        ]);
        return;
      }
    }, [session]);

  return (
    <>
      {!pathname.includes(`login`) && !pathname.includes("signup") && (
        <div className="mobile-only bottom-nav-bar">
          {navItems.map((item, index) => (
            <React.Fragment key={index}>
              {item.label != "Stats" &&
                item.label != "settings" &&
                item.label != "Admins" &&
                item.label != "Catégories" && (
                  <>
                    {notif.includes(item.label) && (
                      <Badge key={uid()}>
                        <Link
                          key={uid()}
                          className={
                            pathname ==
                            `/${currentLocale != "en" ? currentLocale : ""}${
                              item.path
                            }`
                              ? "dark-blue-bg p10 br5"
                              : "p10 br5 "
                          }
                          href={item.path}
                          onClick={() =>
                            setNotif(notif.filter((n) => n !== item.label))
                          }
                        >
                          <>{item.icon}</>
                        </Link>
                      </Badge>
                    )}
                    {!notif.includes(item.label) && (
                      <Link
                        key={uid()}
                        className={
                          item.path != "/" &&
                          pathname ==
                            `/${currentLocale != "en" ? currentLocale : ""}${
                              item.path
                            }`
                            ? "blue-bg white p10 br50"
                            : item.path == "/" &&
                              pathname ==
                                `/${currentLocale != "en" ? currentLocale : ""}`
                            ? "blue-bg white p10 br50"
                            : "p10 br5 dark-grey"
                        }
                        href={item.path}
                      >
                        <>{item.icon}</>
                      </Link>
                    )}
                  </>
                )}
            </React.Fragment>
          ))}
        </div>
      )}
    </>
  );
};

export default BottomNavBar;
